import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material"
import { useMemo } from "react"
import BasicDatePicker from "../../../../../../../components/BasicDatePicker"
import { Controller, useFormContext } from "react-hook-form"
import { formatarInputValorMonetário } from "../../../../../../../helpers/masks"

export default function FormasEntrega() {

    const { watch, control, setValue } = useFormContext()

    const opcoesEntrega = useMemo(() => [
        "Balcão ou expedição",
        "Transportadora"
    ], [])

    const formaEntrega = watch("forma_entrega")


    return (
        <>
            <Controller
                control={control}
                name="forma_entrega"
                rules={{ required: "Campo obrigatório" }}
                render={({ field, fieldState: { invalid, error } }) => (
                    <FormControl>
                        <RadioGroup
                            value={field.value}
                            name="formaEntrega"
                            row
                            onChange={(e) => {
                                setValue("previsao_entrega", null)
                                setValue("valor_frete", "0")
                                field.onChange(e.target.value)}}
                        >
                            {
                                opcoesEntrega.map((item, index) => (
                                    <FormControlLabel key={index} value={item} label={item} control={<Radio />} />
                                ))
                            }
                        </RadioGroup>
                    </FormControl>
                )}
            />
            {
                formaEntrega === "Transportadora" &&
                <Grid container spacing={2} my={1}>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            control={control}
                            name="previsao_entrega"
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { invalid, error } }) => (
                                <BasicDatePicker
                                    label="Previsão de entrega*"
                                    error={invalid}
                                    formatString="DD/MM/YYYY"
                                    helperText={error?.message}
                                    value={field.value}
                                    blockPastDates
                                    onChange={(date) => field.onChange(date)}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            control={control}
                            name="valor_frete"
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { invalid, error } }) => (
                                <TextField
                                    {...field}
                                    required
                                    label="Frete Estimado (R$)"
                                    fullWidth
                                    error={invalid}
                                    helperText={error?.message}
                                    value={field.value}
                                    onChange={(e) => {
                                        const formattedValue = formatarInputValorMonetário(e.target.value)
                                        field.onChange(formattedValue);
                                    }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            }
        </>
    )
}
